import { heroKeywords } from "@/mocks/homeContent";

export default function HeroSection() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div
        className="absolute inset-0 h-full w-full bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20terracotta%20cream%20and%20deep%20amber%20tones%2C%20gentle%20sunlight%20rays%20through%20a%20tall%20modern%20office%20window%2C%20elegant%20minimalist%20cinematic%20atmosphere%2C%20smooth%20painterly%20gradient%20texture%2C%20subtle%20blurred%20bokeh%2C%20moody%20warm%20color%20grading%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=secretary-hero-01&orientation=landscape')",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/65"
        aria-hidden="true"
      />

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-20 md:px-6 md:py-28 lg:py-32">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center animate-rise">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur md:text-sm">
            <span className="flex h-4 w-4 items-center justify-center text-accent-300">
              <i className="ri-sparkling-2-line"></i>
            </span>
            都市职场 · 剧情主题信息整理
          </span>

          <h1 className="font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
            善良的女秘书
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            本页集中说明这一主题的在线播放与完整版资源，涵盖在线观看与完整版、高清播放与无删减在线，并把作品概况、人物关系、内容结构与常见问题整理在一处，帮助你一页读懂它讲了什么、以及该怎样观看。
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#watch"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-play-fill"></i>
              </span>
              查看观看方式
            </a>
            <a
              href="#about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 md:text-base"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-book-open-line"></i>
              </span>
              先了解剧情主题
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-2">
            {heroKeywords.map((kw) => (
              <span
                key={kw}
                className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur"
              >
                {kw}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}